/** Datadog service name; the Dockerfile uploads source maps under the same name. */
export const DD_SERVICE = "consumer-signing-process";
